import React from 'react';
import moment from 'moment';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Page from 'components/page/page.component';
import DocumentList from 'components/document-list/document-list.component';

import { MeetingDocs } from './documents';

const BoardMeetings = () => {
    return (
        <Page
            heroTitle="Board Meetings"
            heroText="Below are the Board of Directors' meeting minutes and agendas."
            heroSize="small"
        >
            <Container>
                <Row>
                    <Col xs="12">
                        <p>
                            Board meetings occur on the Third Friday of every month at 9:00 a.m., unless otherwise
                            noted, and are located at the Muncie Land Bank Office, 326 W. Charles Street Suite A,
                            Muncie, Indiana 47305.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <DocumentList
                            listTitle="meeings"
                            documents={MeetingDocs}
                            sortFunc={(a, b) => {
                                const dateA = moment(a.timestamp);
                                const dateB = moment(b.timestamp);
                                return dateA.isBefore(dateB) ? 1 : -1;
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        </Page>
    );
};

export default BoardMeetings;
